import { Typography } from '@arionbanki/arionui';
import { Markdown, ProgressBar } from 'components';
import { RiskQResultsForm } from './RiskqResultsForm';
import { useRiskqResults } from './useRiskqResults';

export function RiskqResults() {
	const ctx = useRiskqResults();
	return (
		<ProgressBar page="riskq-results">
			<Typography className="mb-5" TagName="h3">
				{ctx.t(`${ctx.flowType}_${ctx.entityType}_title`, 'riskq_results')}
			</Typography>
			<div className="my-3">
				<Markdown>{ctx.t(`${ctx.flowType}_${ctx.entityType}_main_description`, 'riskq_results')}</Markdown>
			</div>
			<RiskQResultsForm {...ctx} />
		</ProgressBar>
	);
}
